import React, { useEffect, useState } from "react";
import AdminLayout from "./Common/AdminLayout";
import { GetAllSubscription,searchAllSubscription } from "../../Redux/Slices/Package";
import "../../asset/new/css/admin-modern.css";

const PackageSalesHistory = () => {
  const [salesHistory, setSalesHistory] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSalesHistory = async (page) => {
    try {
      setLoading(true);
      const res = await GetAllSubscription({ page });
      setSalesHistory(res);
    } catch (error) {
      console.error("Error fetching sales history:", error);
    } finally {
      setLoading(false);
    }
  };

  const searchSalesHistory = async (data) => {
    try {
      setLoading(true);
      const res = await searchAllSubscription({ data });
      setSalesHistory(res);
    } catch (error) {
      console.error("Error fetching sales history:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    let data = {
      page:1,
      search:e.target.value
    };
    searchSalesHistory(data)
    
  };

  useEffect(() => {
    fetchSalesHistory(1);
    document.title = "Sales History | Admin";
  }, []);

  const handlePageChange = async (page) => {
    fetchSalesHistory(page);
  };

  const formatTimestamp = (utcTimestamp) => {
    const dateObject = new Date(utcTimestamp);
    return dateObject.toLocaleString(); // Adjust the format as needed
  };

  // Calculate visible page range
  let startPage = 1;
  let endPage = 1;

  if (salesHistory?.pagination) {
    startPage = Math.max(1, salesHistory.pagination.page - 2);
    endPage = Math.min(
      salesHistory.pagination.totalPages,
      salesHistory.pagination.page + 2
    );

    // Adjust start and end page if close to beginning or end
    if (salesHistory.pagination.page <= 3) {
      endPage = Math.min(5, salesHistory.pagination.totalPages);
    } else if (salesHistory.pagination.page >= salesHistory.pagination.totalPages - 2) {
      startPage = Math.max(1, salesHistory.pagination.totalPages - 4);
    }
  }
  return (
    <AdminLayout
      title="Package Sales History"
      subtitle="View all package purchases and transactions"
    >
      {/* Search Bar */}
      <div className="admin-card" style={{ marginBottom: 'var(--spacing-xl)' }}>
        <div className="admin-card-body">
          <input
            type="search"
            id="form1"
            placeholder="Search by employer name, email, or package..."
            className="admin-input"
            onChange={(e) => handleSearch(e)}
            style={{ maxWidth: '500px' }}
          />
        </div>
      </div>

      {/* Sales Table */}
      <div className="admin-card">
        <div className="admin-card-body" style={{ padding: 0 }}>
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="admin-table" style={{ minWidth: '1200px', width: '100%' }}>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Employer Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>GST No.</th>
                  <th>Package</th>
                  <th>Price</th>
                  <th>Discount</th>
                  <th>GST%</th>
                  <th>Total</th>
                  <th>Offer</th>
                  <th>Purchased On</th>
                  <th>Order ID</th>
                  <th>Validity</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="14">
                      <div className="admin-empty-state">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading sales history...</p>
                      </div>
                    </td>
                  </tr>
                ) : salesHistory?.docs && salesHistory.docs.length > 0 ? (
                  salesHistory.docs.map((value, index) => (
                    <tr key={index}>
                      <td>
                        <span className="admin-badge admin-badge-light">
                          {(salesHistory.pagination?.page - 1) * (salesHistory.pagination?.limit || 10) + index + 1}
                        </span>
                      </td>
                      <td>{value?.employer?.name || "N/A"}</td>
                      <td>{value?.employer?.email || "N/A"}</td>
                      <td>{value?.employer?.mobile || "N/A"}</td>
                      <td>{value?.employer?.gst || "NA"}</td>
                      <td>
                        <span className="admin-badge admin-badge-primary">
                          {value?.package?.name}
                        </span>
                      </td>
                      <td>₹{value?.package?.cost || 0}</td>
                      <td>
                        <span className="admin-badge admin-badge-success">
                          {value?.package?.discount || 0}%
                        </span>
                      </td>
                      <td>{value?.package?.gst}%</td>
                      <td>
                        <strong>₹{parseInt(value?.package?.gst || 0) + parseInt(value?.package?.cost || 0)}</strong>
                      </td>
                      <td>
                        <div className="admin-text-truncate" style={{ maxWidth: "150px" }}>
                          {value?.package?.offer || "N/A"}
                        </div>
                      </td>
                      <td>{formatTimestamp(value?.created_at)}</td>
                      <td>
                        <code style={{ fontSize: "0.8rem" }}>{value?.payment_id}</code>
                      </td>
                      <td>
                        <span className="admin-badge admin-badge-info">
                          {value?.package?.validity_day} Days
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14">
                      <div className="admin-empty-state">
                        <i className="fas fa-receipt fa-3x mb-3"></i>
                        <h4>No Sales History</h4>
                        <p>No package sales have been recorded yet.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {salesHistory?.pagination && salesHistory.docs && salesHistory.docs.length > 0 && (
            <div className="admin-pagination">
              <button
                className="admin-pagination-btn"
                onClick={() => handlePageChange(salesHistory.pagination.prevPage)}
                disabled={!salesHistory.pagination.prevPage}
              >
                <i className="fas fa-chevron-left"></i>
                Previous
              </button>

              <div className="admin-pagination-numbers">
                {Array.from(
                  { length: Math.min(salesHistory.pagination.totalPages, 5) },
                  (_, i) => {
                    const startPageNum = Math.max(1, salesHistory.pagination.page - 2);
                    return startPageNum + i;
                  }
                )
                  .filter((page) => page <= salesHistory.pagination.totalPages)
                  .map((page) => (
                    <button
                      key={page}
                      className={`admin-pagination-number ${salesHistory.pagination.page === page ? "active" : ""}`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  ))}
              </div>

              <button
                className="admin-pagination-btn"
                onClick={() => handlePageChange(salesHistory.pagination.nextPage)}
                disabled={!salesHistory.pagination.nextPage}
              >
                Next
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default PackageSalesHistory;
